/* eslint-disable max-lines */
export interface BookWidgetAem {
  airportsField: {
    from: string;
    to: string;
    flight: string;
    yourDestination: string;
    connectionLabel: string;
    addFlight: string;
    removeFlight: string;
    yourOrigin: string;
    searchModal: AirportSearchModal;
    infoModal: BookWidgetFieldInfoModal;
    destinationAriaLabel: string;
    originAriaLabel: string;
    swapAriaLabel: string;
    departureAriaLabel: string;
  };
  tripTypesField: {
    roundTrip: string;
    onwWay: string;
    multiCity: string;
    tripTypeAriaLabel: string;
  };
  datesField: {
    depart: string;
    return: string;
    datesAriaLabel: string;
    departAriaLabel?: string;
    returnAriaLabel?: string;
    chooseDatesLabel: string;
  };
  passengerField: {
    passengersLabel: string;
    passenger: string;
    passengerAriaLabel: string;
  };
  shopMilesField: {
    shopWithMiles: string;
  };
  refundableFareField: {
    refundableOnly: string;
    infoModal: BookWidgetFieldInfoModal;
  };
  flexDatesField: {
    flexDates: string;
  };
  excludeBasicField: {
    excludeBasic: string;
  };
  includeBasicField: {
    includeBasic: string;
  };
  flexAirportsField: {
    flexAirports: string;
  };
  bestFareOptionsField: {
    bestFare: string;
    infoModal: BookWidgetFieldInfoModal;
  };
  meetingEventCodeField: {
    meetingEventCode: string;
    edpMeetingCodeDisclaimerForProgram: string;
    edpMeetingCodeDisclaimerForNoProgram: string;
    edpMeetingCodeDisclaimerForFare: string;
    edpMeetingCodeDisclaimer: string;
    placeholder: string;
    infoModal: BookWidgetFieldInfoModal;
  };
  edocsLink: string;
  searchBtn: string;
  viewSearchOptionsBtn: string;
  advancedSearchBtn: string;
  defaultValues: DefaultValuesFromAem;
  errorMessages: BookWidgetErrorMsgs;
  helpIconAriaLabel: string;
}
export interface BookWidgetFieldInfoModal {
  title: string;
  description: string;
}

export interface BookWidgetErrorMsgs {
  SBW008: {
    message: string;
    singleMessage: string;
  };
  SBW009: {
    message: string;
    singleMessage: string;
  };
  SBW010: {
    message: string;
    singleMessage: string;
  };
  SBW011: {
    message: string;
    singleMessage: string;
  };
  SBW012: {
    message: string;
    singleMessage: string;
  };
  SBW013: {
    message: string;
    singleMessage: string;
  };
  SBW014: {
    message: string;
    singleMessage: string;
  };
  SBW015: {
    message: string;
    singleMessage: string;
  };
  SBW016: {
    message: string;
    singleMessage: string;
  };
  SBW017: {
    message: string;
    singleMessage: string;
  };
  SBW018: {
    message: string;
    singleMessage: string;
  };
}

export interface DefaultValuesFromAem {
  tripTypeOptions: TripTypeOptions[];
  selectTripType: TripTypeOptions;
  selectedPaxValue: string;
  maxPaxCount: string;
  bestFareOptions: BestFareOption[];
  basicFaresChecked: string;
  showBasicFares: string;
}

export interface AirportSearchModal {
  destinationLabel: string;
  originLabel: string;
  recentSearch: string;
  savedSearch: string;
  searchLabel: string;
  to: string;
  selectLabel: string;
  connectionAirportLabel: string;
}

export interface BestFareOption {
  brandID: string;
  brandName: string;
}

export enum TripTypeOptions {
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
  MULTI_CITY = 'MULTICITY'
}
